import { BaseWebComponentView } from '../framework/BaseWebComponentView';
import { TemplateState } from '../types/common/types';

export class BaseWidgetView extends BaseWebComponentView {
  protected $wrapper: HTMLElement;
  protected translations: any;

  public static isSuccessState($wrapper: Element) {
    return (
      !$wrapper.classList.contains(TemplateState.ERROR) &&
      !$wrapper.classList.contains(TemplateState.EMPTY) &&
      !$wrapper.classList.contains(TemplateState.LOADING) &&
      !$wrapper.classList.contains(TemplateState.MISSING) &&
      !$wrapper.classList.contains(TemplateState.MISSING_MSP) &&
      !$wrapper.classList.contains(TemplateState.DISABLED)
    );
  }

  getDomElements() {
    this.$wrapper = this.shadow.querySelector('.wrapper');
  }

  showLoader() {
    this.resetTemplateState(this.$wrapper);
    this.setTemplateState(this.$wrapper, TemplateState.LOADING);
  }

  hideLoader() {
    this.resetTemplateState(this.$wrapper);
  }

  setErrorTooltip() {
    const tooltips = this.shadow.querySelectorAll('.error-tooltip');
    tooltips.forEach(item => (item.tooltipText = this.commonStrings.widgetLoadingError));
  }

  getDeltaAssessment(value: string | number) {
    return typeof value === 'string' ? Math.sign(parseFloat(value)) : Math.sign(value);
  }

  displayDeltaInElement($deltaElement, deltaValue: string | number, isPositive: boolean = true) {
    /**
     * In Inventory widget we get deltaValue === '0' so we need to check the
     * strings as well
     */
    if (!deltaValue || deltaValue === '0') {
      $deltaElement.innerHTML = '';
      return;
    }

    $deltaElement.innerHTML = deltaValue > 0 ? '+' + deltaValue : deltaValue;

    this.applyDeltaClass($deltaElement, deltaValue, isPositive);
  }

  applyDeltaClass($deltaElement, deltaValue: string | number, isPositive: boolean = true) {
    const $deltaAssessment = this.getDeltaAssessment(deltaValue);

    if ($deltaElement) {
      this.setDeltaClass($deltaElement, $deltaAssessment, isPositive);
    }
  }

  private setDeltaClass(item: Element, sign: number, isPositive: boolean) {
    let deltaCls;

    item.classList.remove('success', 'danger');

    if (isPositive) {
      if (sign === 1) {
        deltaCls = 'success';
      }

      if (sign === -1) {
        deltaCls = 'danger';
      }
    } else {
      if (sign === 1) {
        deltaCls = 'danger';
      }

      if (sign === -1) {
        deltaCls = 'success';
      }
    }

    if (!deltaCls) {
      return;
    }

    item.classList.add(deltaCls);
  }
}
